"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAggregates = exports.isPlainRecord = exports.isSerializableObject = exports.PackageMetaKeys = exports.GlobalMetaKeys = exports.LEVELS = void 0;
exports.LEVELS = [
    "trace",
    "debug",
    "network",
    "timing",
    "local",
    "info",
    "warn",
    "notice",
    "deprecated",
    "error",
    "fatal",
];
exports.GlobalMetaKeys = ["source", "logId", "userAgent", "referrer", "loggerVer"];
exports.PackageMetaKeys = [
    "package",
    "component",
    "service",
    "release",
    "chain",
    "client",
    "contextId",
    "instanceId",
    "commitHash",
];
function isSerializableObject(val) {
    return (val != null &&
        typeof val === "object" &&
        !Array.isArray(val) &&
        "toJSON" in val &&
        typeof val["toJSON"] === "function");
}
exports.isSerializableObject = isSerializableObject;
function isPlainRecord(val) {
    if (val == null || typeof val !== "object" || Array.isArray(val) || isSerializableObject(val)) {
        return false;
    }
    return !Object.values(val).some((v) => v != null && !["number", "string", "boolean"].includes(typeof v));
}
exports.isPlainRecord = isPlainRecord;
function extractAggregates(val, ...exclude) {
    if (!isSerializableObject(val)) {
        return {};
    }
    const obj = val.toJSON();
    if (obj == null || typeof obj !== "object" || Array.isArray(obj) || isSerializableObject(obj)) {
        return {};
    }
    const aggregates = obj["aggregates"];
    if (!isPlainRecord(aggregates)) {
        return {};
    }
    for (const key of exclude) {
        delete aggregates[key];
    }
    return aggregates;
}
exports.extractAggregates = extractAggregates;
//# sourceMappingURL=interface.js.map